// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { DateTime } from 'luxon';
import type { PartialDeep } from 'type-fest';

import * as DateHelpers from '../../../utils/dateHelpers';
import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import Enums from '../Enums';
import {
  NewQuotePolicy,
  QuotePolicy,
  type QuotePolicyWireFormat,
} from '../QuotePolicy/QuotePolicy';

export class QuotePolicyViolation {
  readonly id: string;
  readonly state: Enums.QuotePolicyViolationState;
  readonly comment: string | null;
  readonly reviewerId: string | null;
  readonly reviewerFirstName: string | null;
  readonly reviewerLastName: string | null;
  readonly reviewedAt: DateTime | null;
  readonly quotePolicy: QuotePolicy;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.state = data.state === undefined ? Enums.QuotePolicyViolationState.Pending : data.state;
    this.comment = data.comment === undefined ? null : data.comment;
    this.reviewerId = data.reviewerId === undefined ? null : data.reviewerId;
    this.reviewerFirstName = data.reviewerFirstName === undefined ? null : data.reviewerFirstName;
    this.reviewerLastName = data.reviewerLastName === undefined ? null : data.reviewerLastName;
    this.reviewedAt = DateHelpers.ParseServerNullableDate(data.reviewedAt);
    this.quotePolicy = NewQuotePolicy(data.quotePolicy);
  }

  static zero(): QuotePolicyViolation {
    const zeroValues: ExcludeMethodsDeep<QuotePolicyViolation> = {
      id: NIL_UUID,
      state: Enums.QuotePolicyViolationState.Pending,
      comment: null,
      reviewerId: null,
      reviewerFirstName: null,
      reviewerLastName: null,
      reviewedAt: null,
      quotePolicy: QuotePolicy.zero(),
    };
    return new QuotePolicyViolation(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type QuotePolicyViolationWireFormat = {
  id: string;
  state: string;
  comment: string | null;
  reviewerId: string | null;
  reviewerFirstName: string | null;
  reviewerLastName: string | null;
  reviewedAt: string | null;
  quotePolicy: QuotePolicyWireFormat;
};

type NewQuotePolicyViolationProps = PartialDeep<QuotePolicyViolation, { recurseIntoArrays: true }>;
export const NewQuotePolicyViolation: (
  props: NewQuotePolicyViolationProps,
) => QuotePolicyViolation = (props) => new QuotePolicyViolation(props);

type NewQuotePolicyViolationFromWireFormatProps = PartialDeep<
  QuotePolicyViolationWireFormat,
  { recurseIntoArrays: true }
>;
export const NewQuotePolicyViolationFromWireFormat: (
  props: NewQuotePolicyViolationFromWireFormatProps,
) => QuotePolicyViolation = (props) => new QuotePolicyViolation(props);
